<template>
  <div>
    <basic-container>
      <div>
        <el-form :model="goodsForm">
          <el-form-item label="产品名称" style="display: flex;width:300px;">
            <el-input v-model="goodsForm.name" placeholder="请输入产品名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="产品类型" style="display: flex;width:300px;">
            <el-input v-model.number="goodsForm.productType" placeholder="请输入产品类型" type="number" min="0"
              clearable></el-input>
          </el-form-item>
          <el-form-item label="分组" style="display: flex;width:300px;">
            <el-input v-model.number="goodsForm.grouping" placeholder="请输入分组" type="number" min="0"
              clearable></el-input>
          </el-form-item>
          <!-- 单位 -->
          <el-form-item label="单位" style="display: flex;width:300px;">
            <el-input v-model="goodsForm.unit" placeholder="请输入单位" clearable></el-input>
          </el-form-item>
          <el-form-item label="产品属性" style="display: flex;width:300px;">
            <el-select v-model="goodsForm.calculateType" placeholder="请选择产品属性" clearable>
              <el-option value="2" label="扣板"></el-option>
              <el-option value="3" label="电器"></el-option>
              <el-option value="1" label="辅材"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="产品价格" style="display: flex;width:300px;">
            <el-input v-model="goodsForm.price" placeholder="请输入产品价格" clearable></el-input>
          </el-form-item>
          <el-form-item label="经销商价格" style="display: flex;width:300px;">
            <el-input v-model="goodsForm.shopPrice" placeholder="请输入经销商价格" clearable></el-input>
          </el-form-item>
          <el-form-item label="返利金额" style="display: flex;width:300px;">
            <el-input v-model="goodsForm.rebate" placeholder="请输入返利金额" clearable></el-input>
          </el-form-item>
          <el-form-item label="推广费用" style="display: flex;width:300px;">
            <el-input v-model="goodsForm.laborCost" placeholder="请输入推广费" clearable></el-input>
          </el-form-item> -->
          <!-- 价格配置 -->
          <el-form-item label="价格配置">
            <el-table :data="goodsFormData" border style="width: 100%; margin-top: 20px">
              <!-- 排序 -->
              <el-table-column prop="sort" label="排序" min-width="150">
                <template slot-scope="scope">
                  <el-input v-model.number="scope.row.sort" placeholder="请输入排序" type="number" min="1"
                    clearable></el-input>
                </template>
              </el-table-column>
              <!-- sku的名称 -->
              <el-table-column prop="name" label="sku名称" min-width="150">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.name" placeholder="请输入名称" clearable></el-input>
                </template>
              </el-table-column>
              <!-- sku的value值 -->
              <el-table-column prop="value" label="sku值" min-width="150">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.value" placeholder="请输入值" clearable></el-input>
                </template>
              </el-table-column>
              <!-- 价格 -->
              <el-table-column prop="price" label="价格" min-width="150">
                <template slot-scope="scope">
                  <el-input v-model.number="scope.row.price" placeholder="请输入价格" type="number" min="0"
                    clearable></el-input>
                </template>
              </el-table-column>
              <!-- 客户价格 -->
              <el-table-column prop="customerPrice" label="客户价格" min-width="150">
                <template slot-scope="scope">
                  <el-input v-model.number="scope.row.customerPrice" placeholder="请输入客户价格" type="number" min="0"
                    clearable></el-input>
                </template>
              </el-table-column>
              <!-- 采购价 -->
              <el-table-column prop="purchasePrice" label="采购价" min-width="150">
                <template slot-scope="scope">
                  <el-input v-model.number="scope.row.purchasePrice" placeholder="请输入采购价" type="number" min="0"
                    clearable></el-input>
                </template>
              </el-table-column>
              <!-- splitFlag是否参与计算0 否 1是 -->
              <el-table-column prop="splitFlag" label="是否参与计算" min-width="150">
                <template slot-scope="scope">
                  <el-radio-group v-model="scope.row.splitFlag">
                    <el-radio label="0">否</el-radio>
                    <el-radio label="1">是</el-radio>
                  </el-radio-group>
                </template>
              </el-table-column>
              <!-- 平方用量 -->
              <el-table-column prop="areaUsage" label="平方用量" min-width="150">
                <template slot-scope="scope">
                  <el-input v-model.number="scope.row.areaUsage" placeholder="请输入平方用量" type="number" min="0"
                    clearable></el-input>
                </template>
              </el-table-column>
              <!-- 选择渠道：家装/装饰公司 -->
              <el-table-column prop="channel" label="渠道" min-width="150">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.channel" placeholder="请选择渠道" multiple clearable>
                    <el-option v-for="channel in channels" :key="channel.id" :label="channel.valueName"
                      :value="channel.id">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <!-- 位置：厨房/阳台/卫生间 -->
              <el-table-column prop="position" label="位置" min-width="150">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.position" placeholder="请选择位置" multiple clearable>
                    <el-option v-for="position in positions" :key="position.id" :label="position.valueName"
                      :value="position.id">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <!-- 价格 -->
              <!-- <el-table-column prop="time" label="到期时间" min-width="150">
                <template slot-scope="scope">
                  <div style="display: flex; align-items: center;">
                    <el-input v-model.number="scope.row.time" placeholder="请输入到期时间" type="number" min="1"
                      clearable></el-input>
                    <el-select v-model="scope.row.unit" placeholder="请选择时间单位" clearable style="margin-right: 10px;">
                      <el-option v-for="unit in units" :key="unit.value" :label="unit.valueName"
                        :value="unit.value"></el-option>
                    </el-select>
                  </div>
                </template>
              </el-table-column> -->
              <el-table-column align="center" label="操作" width="150">
                <template slot-scope="scope">
                  <el-button type="text" icon="el-icon-close" size="small"
                    @click="handleSteppingDelete(scope.$index)">删除</el-button>
                  <el-button type="text" icon="el-icon-plus" size="small"
                    @click="handleAddRows(scope.$index)">增加</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-form>
        <!-- <el-form :model="dynamicForm">
          <el-form-item label="动态表单配置">
            <el-table :data="dynamicFormData" border style="width: 100%; margin-top: 20px">
              <el-table-column prop="fieldName" label="sku名称" min-width="150">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.fieldName" placeholder="请输入名称"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="inputType" label="控件类型" min-width="150">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.inputType" placeholder="请选择控件类型" clearable>
                    <el-option v-for="inputType in inputTypes" :key="inputType.id" :label="inputType.name"
                      :value="inputType.id">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="dataSource" label="数据源" min-width="150">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.dataSource" placeholder="请选择数据源" clearable>
                    <el-option v-for="dataSource in dataSources" :key="dataSource.id" :label="dataSource.valueName"
                      :value="dataSource.id">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="isNull" label="是否为空" width="150">
                <template slot-scope="scope">
                  <el-radio-group v-model="scope.row.isNull">
                    <el-radio label="YES">是</el-radio>
                    <el-radio label="NO">否</el-radio>
                  </el-radio-group>
                </template>
              </el-table-column>
              <el-table-column prop="sort" label="排序" width="150">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.sort"></el-input>
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作" width="150">
                <template slot-scope="scope">
                  <el-button type="danger" icon="el-icon-close" size="small"
                    @click="handleSteppingDelete1(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
              <el-table-column align="center" label="配置" width="150">
                <template slot-scope="scope">
                  <el-button type="warning" icon="el-icon-plus" size="small"
                    @click="handleAddRows1(scope.$index)">增加一行</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-form> -->
      </div>
      <div style="width:100%;display:flex;flex-flow:row nowrap;justify-content: center;margin-top:20px">
        <el-button type="danger" size="small" @click="goBack" icon="el-icon-circle-close-outline">返回</el-button>
        <el-button type="primary" size="small" icon="el-icon-circle-check-outline" @click="submit">提交</el-button>
      </div>
    </basic-container>
  </div>
</template>



<script>
import {
  addGoods
} from "@/api/work/ceiling/purWaterGoods";
import { DIC } from "@/const/dic";
import {
  findDataSourceFields,
  findDataSourceAll,
} from "@/api/work/dynamicForm";
export default {
  data() {
    return {
      isPas: false,
      /* units: [
        { value: 'DAY', valueName: '天' },
        { value: 'MOON', valueName: '月' },
        { value: 'YEAR', valueName: '年' },
      ], */
      channels: [
        { id: 1, valueName: '家装渠道' },
        { id: 2, valueName: '分销渠道' }
      ],
      positions: [
        { id: 1, valueName: '厨房' },
        { id: 2, valueName: '阳台' },
        { id: 3, valueName: '卫生间' },
        { id: 4, valueName: '其他' },
      ],
      goodsForm: {
        name: '',
        price: '',
        shopPrice: '',
        rebate: '',
        formType: '',
        calculateType: '' // 产品属性：1-扣板，2-电器，3-辅材
      },
      goodsFormData: [], // 确保这是一个数组
      positionTypes: [],
      inputTypes: [],
      dataSources: [],
      agentIds: [],
      auditors: DIC.SERVICEITEM_AUDITOR,
      clientTypes: DIC.SERVICEITEM_TYPE,
      dynamicForm: {
      },
      dynamicTypes: [], // 确保这是一个数组
      dynamicFormData: [] // 确保这是一个数组
    };
  },
  created() {
    // 初始化goodsTimeInfo
    this.goodsTimeInfo();
    findDataSourceFields().then(res => {
      let data = JSON.parse(res.data);
      this.inputTypes = data;
    });
    findDataSourceAll().then(res => {
      let data = JSON.parse(res.data);
      this.dataSources = data.rows;
    });
    this.initDynamicFormData();
  },
  methods: {
    initDynamicFormData() {
      // 初始化dynamicFormData
      this.dynamicFormData = [{
        fieldName: '',
        inputType: '',
        dataSource: '',
        isNull: '',
        sort: ''
      }];
    },
    goodsTimeInfo() {
      this.goodsForm.name = '';
      this.goodsForm.type = '';
      this.goodsForm.grouping = '';
      // 初始化goodsFormData
      this.goodsFormData = [{
        name: '',
        productType: '',
        grouping: '',
        filters: []
      }];
    },
    goBack() {
      let item = {
        close: true,
        label: "新增净水产品",
        value: "/work/ceiling/purWaterGoods/add"
      };
      this.$store.commit("DEL_TAG", item);
      this.$router.go(-1);
    },
    submit() {
      // 确保提交数据包含客户价格
      const submitData = {
         name: this.goodsForm.name,
        productType: this.goodsForm.productType,
        grouping: this.goodsForm.grouping,
        unit: this.goodsForm.unit,
        calculateType: this.goodsForm.calculateType,
        filters: this.goodsFormData.map(field => ({
          sort: field.sort,
          name: field.name,
          value: field.value,
          price: field.price,
          customerPrice: field.customerPrice, // 添加客户价格字段
          purchasePrice: field.purchasePrice, // 添加采购价字段
          splitFlag: field.splitFlag, // 添加是否参与计算字段
          areaUsage: field.areaUsage, // 添加平方用量字段
          channel: Array.isArray(field.channel) ? field.channel.join(',') : field.channel,
          position: Array.isArray(field.position) ? field.position.join(',') : field.position
        }))
      };

      addGoods(submitData).then(res => {
        if (res.code === '200') {
          this.$message.success('添加成功');
          this.goBack();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleSteppingDelete1(index) {
      if (this.dynamicFormData.length == 1) {
        this.$message({
          showClose: true,
          message: "动态表单不能为空",
          type: "error"
        });
      } else {
        this.dynamicFormData.splice(index, 1);
      }
    },
    handleAddRows1() {
      this.dynamicFormData.push({
        fieldName: '',
        inputType: '',
        dataSource: '',
        isNull: '',
        sort: ''
      });
    },
    handleSteppingDelete(index) {
      if (this.goodsFormData.length == 1) {
        this.$message({
          showClose: true,
          message: "动态产品不能为空",
          type: "error"
        });
      } else {
        this.goodsFormData.splice(index, 1);
      }
    },
    // 添加一行价格配置
    handleAddRows(index) {
      this.goodsFormData.splice(index + 1, 0, {
        name: '',
        value: '',
        price: 0,
        customerPrice: 0, // 添加客户价格字段
        purchasePrice: 0, // 添加采购价字段
        areaUsage: 0, // 添加平方用量字段
        splitFlag: 0, // 添加是否参与计算字段
        channel: [],
        position: [],
        sort: 1
      });
    },
  }
};
</script>

<style></style>